import * as React from "react";
const SvgDelete = (props) => /* @__PURE__ */ React.createElement("svg", { className: "delete", style: {
  enableBackground: "new 0 0 24 24"
}, viewBox: "0 0 24 24", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18,22H6V8H4v13.7C4,22.8,4.9,24,6 ,24h12c1.1,0,2-1.2,2-2.3V8h-2V22z M15,4V2H9v2H2v2h20V4H15z M9,10v10h2V10H9  z M13,10v10h2V10H13z" }));
export default SvgDelete;
